// extracted by mini-css-extract-plugin
export default {"quiz_question":"A6","question_subheader":"B6","why_popup":"C6","why_underline":"E6","MyClassEnterDone":"F6","WhyAskEnterDone":"G6","WhyUnderlineEnterDone":"H6","main_question":"I6"};
    if(module.hot) {
      // 1730991512781
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  